import BorderBox from '#components/a/BorderBox'
import Userinfo from '#components/m/Userinfo'
import {format} from 'ag-common/facades'
import PropTypes from 'prop-types'
import React from 'react'

function Comment({children, authorId, timeStamp, authorName}) {
  return (
    <div className="comment" key={timeStamp}>
      <BorderBox>
        <Userinfo userId={authorId} fallbackUsername={authorName} />
        {children}
        {timeStamp && <p className="text--small alignRight margin-top-10">{format(new Date(timeStamp), 'dd.MM.yy')}</p>}
      </BorderBox>
    </div>
  )
}

Comment.propTypes = {
  children: PropTypes.node,
  authorId: PropTypes.number,
  timeStamp: PropTypes.string,
  authorName: PropTypes.string,
}

export default Comment
